import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { Button, Input, Select } from 'antd';
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Controller } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';

import GetField from '../Components/GetField';
import styles from '../styles';
import ShowFiles from './ShowFiles';
import { deleteQualityCheckItem } from '../Actions';

const AntSelect = GetField(Select);
const AntInput = GetField(Input);
const { Option } = Select;

const AccessoryForm = props => {
  const {
    classes,
    getValues,
    setValue,
    control,
    watch,
    accessoryItem,
    accessoryIndex,
    accessoryAppend,
    accessoryRemove,
    isProductColumn,
    isJobOrder,
    unregister,
  } = props;

  const dispatch = useDispatch();

  const [FileModal, SetFileModal] = useState(false);

  const accessoriesTable = useSelector(
    state => state.inwardItemsForQualityCheckInputTable.accessories
  );
  const factoryIds = useSelector(state => state.factoryIds);
  const rackIds = useSelector(state => state.rackIds);

  const accessoriesArray = useMemo(() => {
    if (accessoriesTable.productNames.length) {
      const productId = getValues(`accessories[${accessoryIndex}].productId`);

      const productIndex = accessoriesTable.productIndexes[productId];

      if (productIndex !== undefined) {
        return accessoriesTable.accessories[productIndex] || [];
      }
    }
    return [];
  }, [accessoriesTable, watch(`accessories[${accessoryIndex}].productId`)]);

  return (
    <>
      <tr>
        {isProductColumn ? (
          <td className={classes.inputTd}>
            <Controller
              name={`accessories[${accessoryIndex}].productId`}
              control={control}
              defaultValue={accessoryItem.productId}
              render={({ field }) => (
                <AntSelect
                  placeholder="Select product"
                  {...field}
                  onChange={value => {
                    field.onChange(value);
                    setValue(`accessories[${accessoryIndex}].factoryId`, null);
                    setValue(`accessories[${accessoryIndex}].racknoId`, null);
                  }}
                >
                  {accessoriesTable.productNames.map(({ product, id }) => (
                    <Option key={id} value={id}>
                      {product}
                    </Option>
                  ))}
                </AntSelect>
              )}
            />
          </td>
        ) : null}
        <td className={classes.inputTd}>
          <Controller
            name={`accessories[${accessoryIndex}].accessoryId`}
            control={control}
            defaultValue={accessoryItem.accessoryId}
            render={({ field }) => (
              <AntSelect
                placeholder="Select accessory"
                {...field}
                onChange={value => {
                  field.onChange(value);
                  setValue(`accessories[${accessoryIndex}].factoryId`, null);
                  setValue(`accessories[${accessoryIndex}].racknoId`, null);
                }}
              >
                {accessoriesArray.map(accessory => (
                  <Option key={accessory.id} value={accessory.id}>
                    {accessory.accessory}
                  </Option>
                ))}
              </AntSelect>
            )}
          />
        </td>
        <td className={classes.inputTd}>
          <Controller
            name={`accessories[${accessoryIndex}].quantity`}
            control={control}
            defaultValue={accessoryItem.quantity}
            render={({ field }) => (
              <AntInput
                {...field}
                placeholder="Quantity"
                type="number"
                min={0}
                size="small"
              />
            )}
          />
        </td>
        <td className={classes.inputTd}>
          <Controller
            name={`accessories[${accessoryIndex}].factoryId`}
            control={control}
            defaultValue={accessoryItem.factoryId}
            render={({ field }) => (
              <AntSelect
                placeholder="Select factory"
                disabled={
                  !isJobOrder &&
                  watch(`accessories[${accessoryIndex}].condition`) ===
                    'rejected'
                }
                {...field}
                onChange={value => {
                  field.onChange(value);
                  setValue(`accessories[${accessoryIndex}].racknoId`, null);
                }}
              >
                {factoryIds.map(factory => (
                  <Option key={factory.id} value={factory.id}>
                    {factory.name}
                  </Option>
                ))}
              </AntSelect>
            )}
          />
        </td>
        <td className={classes.inputTd}>
          <Controller
            name={`accessories[${accessoryIndex}].racknoId`}
            control={control}
            defaultValue={accessoryItem.racknoId}
            render={({ field }) => (
              <AntSelect
                disabled={
                  !isJobOrder &&
                  watch(`accessories[${accessoryIndex}].condition`) ===
                    'rejected'
                }
                placeholder="Selecy rack"
                {...field}
              >
                {rackIds.map(rack => (
                  <Option key={rack.id} value={rack.id}>
                    {rack.rackno}
                  </Option>
                ))}
              </AntSelect>
            )}
          />
        </td>
        <td className={classes.inputTd}>
          <Controller
            name={`accessories[${accessoryIndex}].condition`}
            control={control}
            defaultValue={accessoryItem.condition}
            render={({ field }) => (
              <AntSelect
                placeholder="Select color"
                {...field}
                onChange={value => {
                  field.onChange(value);
                  if (value === 'rejected') {
                    setValue(`accessories[${accessoryIndex}].factoryId`, null);
                    setValue(`accessories[${accessoryIndex}].racknoId`, null);
                  }
                }}
              >
                <Option key="rejected" value="rejected">
                  Rejected
                </Option>
                <Option key="accepted" value="accepted">
                  Accepted
                </Option>
                <Option key="altered" value="altered">
                  Altered
                </Option>
              </AntSelect>
            )}
          />
        </td>
        <td className={classes.inputTd}>
          <Controller
            name={`accessories[${accessoryIndex}].remark`}
            control={control}
            defaultValue={accessoryItem.remark}
            render={({ field }) => <AntInput placeholder="Remark" {...field} />}
          />
        </td>
        <td className={classes.inputTd}>
          <Button onClick={() => SetFileModal(true)}>File</Button>
        </td>
        <td className={classes.inputTd}>
          <DeleteOutlined
            onClick={() => {
              const accessories = getValues('accessories');
              if (accessories && accessories.length > 1) {
                accessoryRemove(accessoryIndex);
                dispatch(deleteQualityCheckItem('accessories', accessoryIndex));
              }
            }}
          />
          &nbsp; &nbsp;
          <PlusCircleOutlined onClick={() => accessoryAppend({})} />
        </td>
      </tr>
      {FileModal ? (
        <ShowFiles
          itemIndex={accessoryIndex}
          itemType="accessories"
          watch={watch}
          setValue={setValue}
          unregister={unregister}
          SetFileModal={SetFileModal}
        />
      ) : null}
    </>
  );
};

AccessoryForm.propTypes = {
  classes: PropTypes.object.isRequired,
  getValues: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  control: PropTypes.any.isRequired,
  watch: PropTypes.func.isRequired,
  unregister: PropTypes.func.isRequired,
  accessoryRemove: PropTypes.func.isRequired,
  accessoryAppend: PropTypes.func.isRequired,
  accessoryItem: PropTypes.object.isRequired,
  accessoryIndex: PropTypes.number.isRequired,
  isProductColumn: PropTypes.bool,
  isJobOrder: PropTypes.bool,
};

export default withStyles(styles)(AccessoryForm);
